import { Component } from '@angular/core';
import {  App } from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';
import { ProblemList } from '../problemlist/problemlist';
import { ProblemDetail } from '../problemdetail/problemdetail';
@Component({
  selector: 'helpcenter-page',
  templateUrl: 'helpcenter.html'
})

export class HelpCenter{
	questions:any[];
	constructor(public global: AppState,public appCtrl: App) {
       this.questions = [
         {"id":"103443333","title":"学校简介","content":"陕西师范大学是教育部直属、国家“211 工程”重点建设大学，国家教师教育“985工程优势学科创新平台”建设高校，是国家培养高等院校、中等学校师资和教育管理干部以及其他高级专门人才的重要基地，被誉为西北地区“教师的摇篮 ”。"},
         {"id":"103443333","title":"学校简介","content":"陕西师范大学是教育部直属、国家“211 工程”重点建设大学，国家教师教育“985工程优势学科创新平台”建设高校，是国家培养高等院校、中等学校师资和教育管理干部以及其他高级专门人才的重要基地，被誉为西北地区“教师的摇篮 ”。"},
         {"id":"103443333","title":"学校简介","content":"陕西师范大学是教育部直属、国家“211 工程”重点建设大学，国家教师教育“985工程优势学科创新平台”建设高校，是国家培养高等院校、中等学校师资和教育管理干部以及其他高级专门人才的重要基地，被誉为西北地区“教师的摇篮 ”。"},

       ];
	}
	viewMore(){
			this.appCtrl.getRootNav().push(ProblemList);
	}
	openQuestionDetail(item){
		this.appCtrl.getRootNav().push(ProblemDetail,item);
	}
}



// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/helpcenter/overview/helpcenter.ts